import React, { createContext, useContext, useState, useEffect } from 'react';

const defaultPreferences = {
  theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
  colorScheme: 'blue',
  fontSize: 'medium',
};

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [preferences, setPreferences] = useState(() => {
    const saved = localStorage.getItem('readometer-preferences');
    const prefs = saved ? JSON.parse(saved) : defaultPreferences;
    
    // Apply initial theme
    if (prefs.theme === 'dark') {
      document.documentElement.classList.add('dark');
    }
    
    // Apply initial color scheme and font size
    document.documentElement.setAttribute('data-color-scheme', prefs.colorScheme);
    document.documentElement.setAttribute('data-font-size', prefs.fontSize);
    
    return prefs;
  });

  useEffect(() => {
    // Save to localStorage
    localStorage.setItem('readometer-preferences', JSON.stringify(preferences));

    // Apply theme
    if (preferences.theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    // Apply color scheme
    document.documentElement.setAttribute('data-color-scheme', preferences.colorScheme);

    // Apply font size
    document.documentElement.setAttribute('data-font-size', preferences.fontSize);
  }, [preferences]);

  const toggleTheme = () => {
    setPreferences(prev => ({
      ...prev,
      theme: prev.theme === 'light' ? 'dark' : 'light'
    }));
  };

  const setColorScheme = (scheme) => {
    setPreferences(prev => ({
      ...prev,
      colorScheme: scheme
    }));
  };

  const setFontSize = (size) => {
    setPreferences(prev => ({
      ...prev,
      fontSize: size
    }));
  };

  const value = {
    ...preferences,
    toggleTheme,
    setColorScheme,
    setFontSize,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
} 